"use client";

import { createTheme } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { themes } from "@collette-travel/collette-common-controls";
import {MarketName} from "@/types/market-context/market-context";
import {Theme} from "@mui/material";

const themeMap: Record<MarketName, Theme> = {
  "COLLETTE": themes.colletteTheme,
  "AAA": themes.aaaTheme,
  "CAA": themes.aaaTheme
};

const getLegacyTheme = (market: MarketName) => {
  const baseTheme = themeMap[market];

// Legacy breakpoint values
  const legacyBreakpointValues = {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    // Legacy Bootstrap-style breakpoints
    zero: 0,
    mobile: 600,
    tablet: 900,
    desktop: 1200,
    wide: 1536,
    legacyMobile: 0,
    legacyTablet: 768,
    legacyDesktop: 992
  };

// Extract theme options from the already-created theme
// Common controls exports a theme created with createTheme(), not raw options
  const baseThemeOptions = {
    // Core theme properties
    palette: {
      ...baseTheme.palette,
      // removing action section of the palette, found this causes more issues and doesn't add a lot (JF)
      action: {}
    },
    typography: baseTheme.typography,
    components: baseTheme.components,
    transitions: baseTheme.transitions,
    spacing: baseTheme.spacing,
    zIndex: baseTheme.zIndex,
    shape: baseTheme.shape,
    shadows: baseTheme.shadows,
    breakpoints: {
      values: baseTheme.breakpoints.values
    },
    // Additional MUI theme properties
    mixins: baseTheme.mixins,
    direction: baseTheme.direction,
    // CSS variables support (if defined)
    ...((baseTheme as any).cssVariables && { cssVariables: (baseTheme as any).cssVariables }),
    // Unstable SX config (if defined)
    ...((baseTheme as any).unstable_sxConfig && { unstable_sxConfig: (baseTheme as any).unstable_sxConfig })
  };

  return createTheme(
    deepmerge(
      baseThemeOptions,
      {
        cssVariables: { cssVarPrefix: "theme" },
        // Then add our custom breakpoints
        breakpoints: {
          // @ts-ignore - We're intentionally adding extra breakpoints
          values: legacyBreakpointValues
        },
        components: {
          MuiDialog: {
            styleOverrides: {
              paper: {
                borderRadius: "10px",
                backgroundColor: "background.default"
              }
            }
          }
        }
      }
    )
  );
};


export default getLegacyTheme;